/*
*
* JS Imports
*
* */

import Accordion from "./scripts/components/component.accordion";
import MobileMenu from "./scripts/components/component.mobileMenu";
import NavHover from "./scripts/components/component.navHover";
import PredictiveSearch from "./scripts/components/component.predictiveSearch";
import Video from "./scripts/components/component.video";
import Slider from "./scripts/components/component.slider";
import Contact from "./scripts/components/component.contact";
import NavAnimation from "./scripts/components/component.navAnimation";
import HeroAnimation from "./scripts/components/component.heroAnimation";
import Quantity from "./scripts/components/component.quantitySelector";
import Account from "./scripts/components/component.account";
import NavOpenCart from "./scripts/components/component.navCart";
import Filter from "./scripts/components/component.filter";
import QuickAdd from "./scripts/components/component.quickAdd";
import QuickView from "./scripts/components/component.quickView";
import ArticleSteps from "./scripts/components/component.articleSteps";
import BlogVideo from "./scripts/components/component.blogVideo";
import Promobar from "./scripts/components/component.promobar";
import "./scripts/components/component.gorgias";

setTimeout(() => {
	;( function(){
		Accordion.init();
		MobileMenu.init();
		NavHover.init();
		PredictiveSearch.init();
		Video.init();
		Slider.init();
		Contact.init();
		NavAnimation.init()
		HeroAnimation.init();
		Quantity.init();
		Account.init();
		NavOpenCart.init();
		Filter.init();
		QuickAdd.init();
		QuickView.init();
		ArticleSteps.init();
		Promobar.init();
		BlogVideo.init();
	})();
},100)
